var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FontAwesomeIcon',{attrs:{"icon":"times"}})
}
var staticRenderFns = []

export { render, staticRenderFns }